type Props = { reversed?: boolean; markOnly?: boolean; height?: number };

/**
 * Inline logo lockup. Rendered as markup (not the imported SVG asset) so the
 * wordmark uses the page's loaded Archivo webfont rather than falling back to
 * a system face inside an <img>. Mirrors packages/brand/assets/logos.
 */
export default function Logo({ reversed = false, markOnly = false, height = 30 }: Props) {
  const stroke = reversed ? "#FAFAF9" : "#FAFAF9";
  const wordColor = reversed ? "#FAFAF9" : "var(--core-ink)";
  const subColor = reversed ? "var(--core-accent)" : "var(--core-primary-dark)";
  const size = height;

  return (
    <span
      style={{ display: "inline-flex", alignItems: "center", gap: markOnly ? 0 : Math.round(size * 0.34) }}
      aria-label="Agile Software Ltd"
      role="img"
    >
      <svg width={size} height={size} viewBox="0 0 64 64" aria-hidden="true">
        {!reversed && <rect width="64" height="64" rx="14" fill="#18181B" />}
        <g transform="translate(7 0) skewX(-11)">
          <path
            d="M20 46 L32 18 L44 46"
            fill="none"
            stroke={reversed ? "#FAFAF9" : stroke}
            strokeWidth="6"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <line x1="25" y1="37" x2="39" y2="37" stroke="#14B8A6" strokeWidth="6" strokeLinecap="round" />
        </g>
      </svg>
      {!markOnly && (
        <span style={{ display: "flex", flexDirection: "column", lineHeight: 1 }}>
          <span
            style={{
              fontFamily: "var(--core-font-display)",
              fontWeight: 800,
              fontStyle: "italic",
              fontSize: size * 0.68,
              letterSpacing: "-0.02em",
              color: wordColor,
            }}
          >
            Agile&nbsp;Software
          </span>
          <span
            style={{
              fontFamily: "var(--core-font-display)",
              fontWeight: 700,
              fontSize: size * 0.28,
              letterSpacing: "0.34em",
              textTransform: "uppercase",
              color: subColor,
              marginTop: size * 0.08,
            }}
          >
            Limited
          </span>
        </span>
      )}
    </span>
  );
}
